import { useNavigate } from "react-router-dom";

export function SupportHeader({ breadcrumb, title, rightAction }) {
  const navigate = useNavigate();

  return (
    <div style={{ marginBottom: 40, marginTop: 16 }}>
      {/* Breadcrumb */}
      <div
        className="text-muted"
        style={{
          fontSize: 13,
          marginBottom: 14,
        }}
      >
        {breadcrumb}
      </div>

      {/* Title Row */}
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ gap: 12 }}
      >
        <div className="d-flex align-items-center gap-3">
          <span
            style={{
              cursor: "pointer",
              fontSize: 20,
              lineHeight: 1,
            }}
            onClick={() => navigate(-1)}
          >
            ←
          </span>

          <h4 className="mb-0 fw-bold">{title}</h4>
        </div>
        {rightAction && <div>{rightAction}</div>}
      </div>
    </div>
  );
}